import styled from 'styled-components';

export const Icon = styled.div`
  cursor: pointer;

  &:hover {
    color: hsla(18, 99%, 70%, 1);
  }
`;
